import * as React from "react";

import { useBrand } from "../../hooks/useBrand";

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

/** The site's logo: the tenant's, or njoy's where it sets none. */
export const BrandLogo: React.FC<Props> = (props) => {
  const { appName, logoUrl } = useBrand();
  return <img {...props} src={logoUrl} alt={appName} />;
};
